import React, { useState, useEffect } from 'react';
import { calculateCompleteTax, formatCurrency } from '../../utils/taxCalculations';

const SalaryInvestmentForm = ({ data, updateData, personalInfo, salaryIncome, salaryExpenses, nextStep, prevStep, isLastStep, isProcessing }) => {
    const [formData, setFormData] = useState({
        // C. Lifestyle & Discretionary
        entertainment: data?.entertainment || '',
        diningOutAmount: data?.diningOutAmount || '',
        diningOut: data?.diningOut || '',
        diningOutFrequency: data?.diningOutFrequency || 'monthly',
        
        moviesTheaterAmount: data?.moviesTheaterAmount || '',
        moviesTheater: data?.moviesTheater || '',
        moviesTheaterFrequency: data?.moviesTheaterFrequency || 'monthly',
        
        sportsHobbies: data?.sportsHobbies || '',
        sportsHobbiesAmount: data?.sportsHobbiesAmount || '',
        sportsHobbiesFrequency: data?.sportsHobbiesFrequency || 'monthly',
        clubMemberships: data?.clubMemberships || '',
        clubMembershipsAmount: data?.clubMembershipsAmount || '',
        clubMembershipsFrequency: data?.clubMembershipsFrequency || 'annually',

        electronicsAmount: data?.electronicsAmount || '',
        electronics: data?.electronics || '',
        electronicsFrequency: data?.electronicsFrequency || 'annually',
        
        furnitureDecorAmount: data?.furnitureDecorAmount || '',
        furnitureDecor: data?.furnitureDecor || '',
        furnitureDecorFrequency: data?.furnitureDecorFrequency || 'annually',
        
        apparelAccessoriesAmount: data?.apparelAccessoriesAmount || '',
        apparelAccessories: data?.apparelAccessories || '',
        apparelAccessoriesFrequency: data?.apparelAccessoriesFrequency || 'quarterly',
        
        giftsDonationsAmount: data?.giftsDonationsAmount || '',
        giftsDonations: data?.giftsDonations || '',
        giftsDonationsFrequency: data?.giftsDonationsFrequency || 'annually',

        travel: data?.travel || '',
        vacationPlanning: data?.vacationPlanning || '',
        vacationPlanningAmount: data?.vacationPlanningAmount || '',
        vacationPlanningFrequency: data?.vacationPlanningFrequency || 'annually',
        dailyOfficeCommute: data?.dailyOfficeCommute || '',

        // D. Financial Obligations & Investments
        incomeTaxAdvance: data?.incomeTaxAdvance || '',
        tdsInterestIncome: data?.tdsInterestIncome || '',
        capitalGainsTax: data?.capitalGainsTax || '',

        elssAmount: data?.elssAmount || '',
        elss: data?.elss || '',
        elssFrequency: data?.elssFrequency || 'monthly',
        
        mutualFundsAmount: data?.mutualFundsAmount || '',
        mutualFunds: data?.mutualFunds || '',
        mutualFundsFrequency: data?.mutualFundsFrequency || 'monthly',
        
        stocksEquityAmount: data?.stocksEquityAmount || '',
        stocksEquity: data?.stocksEquity || '',
        stocksEquityFrequency: data?.stocksEquityFrequency || 'monthly',
        
        recurringDepositsAmount: data?.recurringDepositsAmount || '',
        recurringDeposits: data?.recurringDeposits || '',
        recurringDepositsFrequency: data?.recurringDepositsFrequency || 'monthly',
        
        fixedDepositsAmount: data?.fixedDepositsAmount || '',
        fixedDeposits: data?.fixedDeposits || '',
        fixedDepositsFrequency: data?.fixedDepositsFrequency || 'annually',
        
        goldBondsAmount: data?.goldBondsAmount || '',
        goldBonds: data?.goldBonds || '',
        goldBondsFrequency: data?.goldBondsFrequency || 'annually',
        
        realEstateAmount: data?.realEstateAmount || '',
        realEstate: data?.realEstate || '',
        realEstateFrequency: data?.realEstateFrequency || 'annually',

        emergencyFund: data?.emergencyFund || '',
        emergencyFundAmount: data?.emergencyFundAmount || '',
        emergencyFundFrequency: data?.emergencyFundFrequency || 'monthly',
        liquidFund: data?.liquidFund || '',
        liquidFundAmount: data?.liquidFundAmount || '',
        liquidFundFrequency: data?.liquidFundFrequency || 'monthly',

        // E. Family & Social
        parentingSupport: data?.parentingSupport || '',
        childrenAllowance: data?.childrenAllowance || '',
        domesticHelp: data?.domesticHelp || '',

        weddingContributionsAmount: data?.weddingContributionsAmount || '',
        weddingContributions: data?.weddingContributions || '',
        weddingContributionsFrequency: data?.weddingContributionsFrequency || 'annually',
        
        festivalExpensesAmount: data?.festivalExpensesAmount || '',
        festivalExpenses: data?.festivalExpenses || '',
        festivalExpensesFrequency: data?.festivalExpensesFrequency || 'annually',
        
        religiousDonationsAmount: data?.religiousDonationsAmount || '',
        religiousDonations: data?.religiousDonations || '',
        religiousDonationsFrequency: data?.religiousDonationsFrequency || 'annually',
        
        charityNGOAmount: data?.charityNGOAmount || '',
        charityNGO: data?.charityNGO || '',
        charityNGOFrequency: data?.charityNGOFrequency || 'annually',

        birthdayCelebrationsAmount: data?.birthdayCelebrationsAmount || '',
        birthdayCelebrations: data?.birthdayCelebrations || '',
        birthdayCelebrationsFrequency: data?.birthdayCelebrationsFrequency || 'annually',
        
        anniversaryCelebrationsAmount: data?.anniversaryCelebrationsAmount || '',
        anniversaryCelebrations: data?.anniversaryCelebrations || '',
        anniversaryCelebrationsFrequency: data?.anniversaryCelebrationsFrequency || 'annually',
        
        familyFunctionsAmount: data?.familyFunctionsAmount || '',
        familyFunctions: data?.familyFunctions || '',
        familyFunctionsFrequency: data?.familyFunctionsFrequency || 'annually',

        // F. Professional Expenses
        professionalCoursesAmount: data?.professionalCoursesAmount || '',
        professionalCourses: data?.professionalCourses || '',
        professionalCoursesFrequency: data?.professionalCoursesFrequency || 'annually',
        
        certificationFeesAmount: data?.certificationFeesAmount || '',
        certificationFees: data?.certificationFees || '',
        certificationFeesFrequency: data?.certificationFeesFrequency || 'annually',
        
        booksJournalsAmount: data?.booksJournalsAmount || '',
        booksJournals: data?.booksJournals || '',
        booksJournalsFrequency: data?.booksJournalsFrequency || 'annually',
        
        workFromHomeAmount: data?.workFromHomeAmount || '',
        workFromHome: data?.workFromHome || '',
        workFromHomeFrequency: data?.workFromHomeFrequency || 'monthly',
        
        professionalMembershipAmount: data?.professionalMembershipAmount || '',
        professionalMembership: data?.professionalMembership || '',
        professionalMembershipFrequency: data?.professionalMembershipFrequency || 'annually',

        officeCabTravel: data?.officeCabTravel || '',
        businessMeals: data?.businessMeals || '',

        professionalTax: data?.professionalTax || '',
    });

    const [expandedSections, setExpandedSections] = useState({
        lifestyle: false,
        shopping: false,
        travel: false,
        tax: false,
        investments: false,
        emergency: false,
        family: false,
        social: false,
        occasions: false,
        professional: false,
        commuting: false,
    });


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        updateData(formData);
        nextStep(formData);
    };

    const toggleSection = (section) => {
        setExpandedSections(prev => ({ ...prev, [section]: !prev[section] }));
    };

    const handleVacationPlanningChange = (field, value) => {
        const newFormData = { ...formData, [field]: value };
        
        // Calculate monthly value based on frequency
        if (field === 'vacationPlanningAmount' || field === 'vacationPlanningFrequency') {
            const amount = parseFloat(newFormData.vacationPlanningAmount) || 0;
            const frequency = newFormData.vacationPlanningFrequency;
            let monthlyValue = 0;
            
            switch (frequency) {
                case 'annually':
                    monthlyValue = amount / 12;
                    break;
                case 'sixMonthly':
                    monthlyValue = amount / 6;
                    break;
                default:
                    monthlyValue = amount / 12;
            }
            
            newFormData.vacationPlanning = monthlyValue > 0 ? monthlyValue.toFixed(2) : '';
        }
        
        setFormData(newFormData);
    };

    // Sports/Hobbies with Monthly/Annually frequency
    const handleSportsHobbiesChange = (field, value) => {
        const newFormData = { ...formData, [field]: value };
        
        if (field === 'sportsHobbiesAmount' || field === 'sportsHobbiesFrequency') {
            const amount = parseFloat(newFormData.sportsHobbiesAmount) || 0;
            const frequency = newFormData.sportsHobbiesFrequency || 'monthly';
            
            let monthlyValue = 0;
            switch (frequency) {
                case 'monthly':
                    monthlyValue = amount;
                    break;
                case 'annually':
                default:
                    monthlyValue = amount / 12;
            }
            
            newFormData.sportsHobbies = monthlyValue > 0 ? monthlyValue.toFixed(2) : '';
        }
        
        setFormData(newFormData);
    };

    // General handler for fields with frequency (calculates monthly value)
    const handleFrequencyExpenseChange = (field, value) => {
        const newFormData = { ...formData, [field]: value };
        
        // Extract the base field name
        const baseField = field.replace('Amount', '').replace('Frequency', '');
        const amountField = `${baseField}Amount`;
        const freqField = `${baseField}Frequency`;
        
        const amount = parseFloat(newFormData[amountField]) || 0;
        const frequency = newFormData[freqField];
        
        let monthlyValue = 0;
        switch (frequency) {
            case 'monthly':
                monthlyValue = amount;
                break;
            case 'quarterly':
                monthlyValue = amount / 3;
                break;
            case 'sixMonthly':
            case 'halfYearly':
                monthlyValue = amount / 6;
                break;
            case 'annually':
                monthlyValue = amount / 12;
                break;
            default:
                monthlyValue = amount;
        }
        
        newFormData[baseField] = monthlyValue > 0 ? monthlyValue.toFixed(2) : '';
        setFormData(newFormData);
    };

    return (
        <div className="form-step">
            <h2 className="step-title">Part 3: Discretionary & Investments</h2>
            <p className="step-description">Lifestyle expenses and financial planning</p>

            <form onSubmit={handleSubmit} className="diagnosis-form">

                {/* Lifestyle & Discretionary */}
                <div className="expense-section">
                    <h4 className="subsection-title collapsible" onClick={() => toggleSection('lifestyle')}>
                        <span>1. Entertainment & Leisure</span>
                        <span className="toggle-icon">{expandedSections.lifestyle ? '▼' : '▶'}</span>
                    </h4>
                    {expandedSections.lifestyle && (
                        <>
                            <FrequencyInputGroup 
                                label="Dining Out (Restaurants, Cafes)" 
                                name="diningOutAmount" 
                                value={formData.diningOutAmount} 
                                frequency={formData.diningOutFrequency}
                                freqName="diningOutFrequency"
                                options={['monthly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('diningOutAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('diningOutFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Movies/Theater" 
                                name="moviesTheaterAmount" 
                                value={formData.moviesTheaterAmount} 
                                frequency={formData.moviesTheaterFrequency}
                                freqName="moviesTheaterFrequency"
                                options={['monthly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('moviesTheaterAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('moviesTheaterFrequency', val)}
                            />
                            <SportsHobbiesInput
                                amount={formData.sportsHobbiesAmount}
                                frequency={formData.sportsHobbiesFrequency}
                                onChange={handleSportsHobbiesChange}
                            />
                            <ClubMembershipsInput
                                amount={formData.clubMembershipsAmount}
                                frequency={formData.clubMembershipsFrequency}
                                onChange={handleFrequencyExpenseChange}
                            />
                        </>
                    )}
                </div>

                {/* Shopping */}
                <div className="expense-section">
                    <h4 className="subsection-title collapsible" onClick={() => toggleSection('shopping')}>
                        <span>2. Shopping</span>
                        <span className="toggle-icon">{expandedSections.shopping ? '▼' : '▶'}</span>
                    </h4>
                    {expandedSections.shopping && (
                        <>
                            <FrequencyInputGroup 
                                label="Electronics & Gadgets" 
                                name="electronicsAmount" 
                                value={formData.electronicsAmount} 
                                frequency={formData.electronicsFrequency}
                                freqName="electronicsFrequency"
                                options={['quarterly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('electronicsAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('electronicsFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Furniture & Home Decor" 
                                name="furnitureDecorAmount" 
                                value={formData.furnitureDecorAmount} 
                                frequency={formData.furnitureDecorFrequency}
                                freqName="furnitureDecorFrequency"
                                options={['quarterly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('furnitureDecorAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('furnitureDecorFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Apparel & Accessories" 
                                name="apparelAccessoriesAmount" 
                                value={formData.apparelAccessoriesAmount} 
                                frequency={formData.apparelAccessoriesFrequency}
                                freqName="apparelAccessoriesFrequency"
                                options={['quarterly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('apparelAccessoriesAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('apparelAccessoriesFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Gifts & Donations" 
                                name="giftsDonationsAmount" 
                                value={formData.giftsDonationsAmount} 
                                frequency={formData.giftsDonationsFrequency}
                                freqName="giftsDonationsFrequency"
                                options={['quarterly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('giftsDonationsAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('giftsDonationsFrequency', val)}
                            />
                        </>
                    )}
                </div>

                {/* Travel */}
                <div className="expense-section">
                    <h4 className="subsection-title collapsible" onClick={() => toggleSection('travel')}>
                        <span>3. Travel</span>
                        <span className="toggle-icon">{expandedSections.travel ? '▼' : '▶'}</span>
                    </h4>
                    {expandedSections.travel && (
                        <>
                            <VacationPlanningInput 
                                amount={formData.vacationPlanningAmount}
                                frequency={formData.vacationPlanningFrequency}
                                monthlyValue={formData.vacationPlanning}
                                onChange={handleVacationPlanningChange}
                            />
                            <InputGroup label="Daily Office Commute (if not in Transportation)" name="dailyOfficeCommute" value={formData.dailyOfficeCommute} onChange={handleChange} />
                        </>
                    )}
                </div>

                {/* Tax Payments */}
                <div className="expense-section">
                    <h4 className="subsection-title collapsible" onClick={() => toggleSection('tax')}>
                        <span>4. Tax Payments (Monthly)</span>
                        <span className="toggle-icon">{expandedSections.tax ? '▼' : '▶'}</span>
                    </h4>
                    {expandedSections.tax && (
                        <>
                            <InputGroup label="Income Tax (Advance Tax/Self-Assessment)" name="incomeTaxAdvance" value={formData.incomeTaxAdvance} onChange={handleChange} />
                            <InputGroup label="TDS on Interest Income" name="tdsInterestIncome" value={formData.tdsInterestIncome} onChange={handleChange} />
                            <InputGroup label="Capital Gains Tax Provision" name="capitalGainsTax" value={formData.capitalGainsTax} onChange={handleChange} />
                            <InputGroup label="Professional Tax (if applicable)" name="professionalTax" value={formData.professionalTax} onChange={handleChange} />
                        </>
                    )}
                </div>

                {/* Investments */}
                <div className="expense-section">
                    <h4 className="subsection-title collapsible" onClick={() => toggleSection('investments')}>
                        <span>5. Investments (Voluntary)</span>
                        <span className="toggle-icon">{expandedSections.investments ? '▼' : '▶'}</span>
                    </h4>
                    {expandedSections.investments && (
                        <>
                            <FrequencyInputGroup 
                                label="Equity Linked Savings Scheme (ELSS)" 
                                name="elssAmount" 
                                value={formData.elssAmount} 
                                frequency={formData.elssFrequency}
                                freqName="elssFrequency"
                                options={['monthly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('elssAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('elssFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Mutual Funds (Equity, Debt, Hybrid)" 
                                name="mutualFundsAmount" 
                                value={formData.mutualFundsAmount} 
                                frequency={formData.mutualFundsFrequency}
                                freqName="mutualFundsFrequency"
                                options={['monthly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('mutualFundsAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('mutualFundsFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Stocks/Direct Equity" 
                                name="stocksEquityAmount" 
                                value={formData.stocksEquityAmount} 
                                frequency={formData.stocksEquityFrequency}
                                freqName="stocksEquityFrequency"
                                options={['monthly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('stocksEquityAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('stocksEquityFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Recurring Deposits (RD)" 
                                name="recurringDepositsAmount" 
                                value={formData.recurringDepositsAmount} 
                                frequency={formData.recurringDepositsFrequency}
                                freqName="recurringDepositsFrequency"
                                options={['monthly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('recurringDepositsAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('recurringDepositsFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Fixed Deposits (FD)" 
                                name="fixedDepositsAmount" 
                                value={formData.fixedDepositsAmount} 
                                frequency={formData.fixedDepositsFrequency}
                                freqName="fixedDepositsFrequency"
                                options={['monthly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('fixedDepositsAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('fixedDepositsFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Gold (Physical, ETFs, Sovereign Bonds)" 
                                name="goldBondsAmount" 
                                value={formData.goldBondsAmount} 
                                frequency={formData.goldBondsFrequency}
                                freqName="goldBondsFrequency"
                                options={['monthly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('goldBondsAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('goldBondsFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Real Estate Investments" 
                                name="realEstateAmount" 
                                value={formData.realEstateAmount} 
                                frequency={formData.realEstateFrequency}
                                freqName="realEstateFrequency"
                                options={['monthly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('realEstateAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('realEstateFrequency', val)}
                            />
                        </>
                    )}
                </div>

                {/* Emergency Fund */}
                <div className="expense-section">
                    <h4 className="subsection-title collapsible" onClick={() => toggleSection('emergency')}>
                        <span>6. Emergency Fund Contribution</span>
                        <span className="toggle-icon">{expandedSections.emergency ? '▼' : '▶'}</span>
                    </h4>
                    {expandedSections.emergency && (
                        <>
                            <FrequencyInputGroup 
                                label="Liquid Fund/Savings Buffer" 
                                name="liquidFundAmount" 
                                value={formData.liquidFundAmount} 
                                frequency={formData.liquidFundFrequency}
                                freqName="liquidFundFrequency"
                                options={['monthly', 'quarterly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('liquidFundAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('liquidFundFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Emergency Fund Contribution" 
                                name="emergencyFundAmount" 
                                value={formData.emergencyFundAmount} 
                                frequency={formData.emergencyFundFrequency}
                                freqName="emergencyFundFrequency"
                                options={['monthly', 'quarterly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('emergencyFundAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('emergencyFundFrequency', val)}
                            />
                        </>
                    )}
                </div>

                {/* Family Obligations */}
                <div className="expense-section">
                    <h4 className="subsection-title collapsible" onClick={() => toggleSection('family')}>
                        <span>7. Family Obligations (Monthly)</span>
                        <span className="toggle-icon">{expandedSections.family ? '▼' : '▶'}</span>
                    </h4>
                    {expandedSections.family && (
                        <>
                            <InputGroup label="Parenting/Aging Support" name="parentingSupport" value={formData.parentingSupport} onChange={handleChange} />
                            <InputGroup label="Children's Allowance" name="childrenAllowance" value={formData.childrenAllowance} onChange={handleChange} />
                            <InputGroup label="Domestic Help Salary" name="domesticHelp" value={formData.domesticHelp} onChange={handleChange} />
                        </>
                    )}
                </div>

                {/* Social & Religious */}
                <div className="expense-section">
                    <h4 className="subsection-title collapsible" onClick={() => toggleSection('social')}>
                        <span>8. Social & Religious</span>
                        <span className="toggle-icon">{expandedSections.social ? '▼' : '▶'}</span>
                    </h4>
                    {expandedSections.social && (
                        <>
                            <FrequencyInputGroup 
                                label="Wedding/Gift Contributions" 
                                name="weddingContributionsAmount" 
                                value={formData.weddingContributionsAmount} 
                                frequency={formData.weddingContributionsFrequency}
                                freqName="weddingContributionsFrequency"
                                options={['monthly', 'quarterly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('weddingContributionsAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('weddingContributionsFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Festival Expenses" 
                                name="festivalExpensesAmount" 
                                value={formData.festivalExpensesAmount} 
                                frequency={formData.festivalExpensesFrequency}
                                freqName="festivalExpensesFrequency"
                                options={['monthly', 'quarterly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('festivalExpensesAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('festivalExpensesFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Religious Donations/Temple Contributions" 
                                name="religiousDonationsAmount" 
                                value={formData.religiousDonationsAmount} 
                                frequency={formData.religiousDonationsFrequency}
                                freqName="religiousDonationsFrequency"
                                options={['monthly', 'quarterly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('religiousDonationsAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('religiousDonationsFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Charity/NGO Donations" 
                                name="charityNGOAmount" 
                                value={formData.charityNGOAmount} 
                                frequency={formData.charityNGOFrequency}
                                freqName="charityNGOFrequency"
                                options={['monthly', 'quarterly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('charityNGOAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('charityNGOFrequency', val)}
                            />
                        </>
                    )}
                </div>

                {/* Special Occasions */}
                <div className="expense-section">
                    <h4 className="subsection-title collapsible" onClick={() => toggleSection('occasions')}>
                        <span>9. Special Occasions</span>
                        <span className="toggle-icon">{expandedSections.occasions ? '▼' : '▶'}</span>
                    </h4>
                    {expandedSections.occasions && (
                        <>
                            <FrequencyInputGroup 
                                label="Birthday Celebrations" 
                                name="birthdayCelebrationsAmount" 
                                value={formData.birthdayCelebrationsAmount} 
                                frequency={formData.birthdayCelebrationsFrequency}
                                freqName="birthdayCelebrationsFrequency"
                                options={['quarterly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('birthdayCelebrationsAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('birthdayCelebrationsFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Anniversary Celebrations" 
                                name="anniversaryCelebrationsAmount" 
                                value={formData.anniversaryCelebrationsAmount} 
                                frequency={formData.anniversaryCelebrationsFrequency}
                                freqName="anniversaryCelebrationsFrequency"
                                options={['quarterly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('anniversaryCelebrationsAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('anniversaryCelebrationsFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Family Functions" 
                                name="familyFunctionsAmount" 
                                value={formData.familyFunctionsAmount} 
                                frequency={formData.familyFunctionsFrequency}
                                freqName="familyFunctionsFrequency"
                                options={['quarterly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('familyFunctionsAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('familyFunctionsFrequency', val)}
                            />
                        </>
                    )}
                </div>

                {/* Professional Expenses */}
                <div className="expense-section">
                    <h4 className="subsection-title collapsible" onClick={() => toggleSection('professional')}>
                        <span>10. Work-Related</span>
                        <span className="toggle-icon">{expandedSections.professional ? '▼' : '▶'}</span>
                    </h4>
                    {expandedSections.professional && (
                        <>
                            <FrequencyInputGroup 
                                label="Professional Development Courses" 
                                name="professionalCoursesAmount" 
                                value={formData.professionalCoursesAmount} 
                                frequency={formData.professionalCoursesFrequency}
                                freqName="professionalCoursesFrequency"
                                options={['monthly', 'quarterly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('professionalCoursesAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('professionalCoursesFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Certification Fees" 
                                name="certificationFeesAmount" 
                                value={formData.certificationFeesAmount} 
                                frequency={formData.certificationFeesFrequency}
                                freqName="certificationFeesFrequency"
                                options={['monthly', 'quarterly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('certificationFeesAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('certificationFeesFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Books & Journals" 
                                name="booksJournalsAmount" 
                                value={formData.booksJournalsAmount} 
                                frequency={formData.booksJournalsFrequency}
                                freqName="booksJournalsFrequency"
                                options={['monthly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('booksJournalsAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('booksJournalsFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Work-from-Home Setup (if not reimbursed)" 
                                name="workFromHomeAmount" 
                                value={formData.workFromHomeAmount} 
                                frequency={formData.workFromHomeFrequency}
                                freqName="workFromHomeFrequency"
                                options={['monthly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('workFromHomeAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('workFromHomeFrequency', val)}
                            />
                            <FrequencyInputGroup 
                                label="Professional Membership Fees" 
                                name="professionalMembershipAmount" 
                                value={formData.professionalMembershipAmount} 
                                frequency={formData.professionalMembershipFrequency}
                                freqName="professionalMembershipFrequency"
                                options={['monthly', 'annually']}
                                onChange={(e) => handleFrequencyExpenseChange('professionalMembershipAmount', e.target.value)}
                                onFreqChange={(val) => handleFrequencyExpenseChange('professionalMembershipFrequency', val)}
                            />
                        </>
                    )}
                </div>

                {/* Commuting to Office */}
                <div className="expense-section">
                    <h4 className="subsection-title collapsible" onClick={() => toggleSection('commuting')}>
                        <span>11. Commuting to Office (Monthly)</span>
                        <span className="toggle-icon">{expandedSections.commuting ? '▼' : '▶'}</span>
                    </h4>
                    {expandedSections.commuting && (
                        <>
                            <InputGroup label="Office Cab/Travel (if not provided)" name="officeCabTravel" value={formData.officeCabTravel} onChange={handleChange} />
                            <InputGroup label="Business Meals (if not reimbursed)" name="businessMeals" value={formData.businessMeals} onChange={handleChange} />
                        </>
                    )}
                </div>

                <div className="form-actions">
                    <button type="button" onClick={() => { updateData(formData); prevStep(); }} className="btn-secondary">← Back</button>
                    <button type="submit" className="btn-primary" disabled={isProcessing}>
                        {isProcessing ? 'Processing...' : (isLastStep ? 'Generate Report →' : 'Next Step →')}
                    </button>
                </div>
            </form>

            <style jsx>{`
                .expense-section { margin-bottom: 25px; padding: 15px; background: #f9fafb; border-radius: 8px; }
                .subsection-title { color: #4b5563; margin-bottom: 12px; font-size: 0.95rem; font-weight: 600; }
                .subsection-title.collapsible { cursor: pointer; user-select: none; display: flex; justify-content: space-between; align-items: center; padding: 10px; background: #fff; border-radius: 6px; transition: background-color 0.2s; }
                .subsection-title.collapsible:hover { background: #f3f4f6; }
                .toggle-icon { font-size: 0.8rem; color: #6b7280; }
            `}</style>
        </div>
    );
};

const FrequencyInputGroup = ({ label, name, value, frequency, freqName, options = ['monthly', 'annually'], onChange, onFreqChange }) => {
    const inputValue = value === null || value === undefined ? '' : String(value);
    
    let divisor = 1;
    if (frequency === 'annually') divisor = 12;
    else if (frequency === 'quarterly') divisor = 3;
    else if (frequency === 'sixMonthly' || frequency === 'halfYearly') divisor = 6;
    
    const monthlyValue = parseFloat(value) > 0 && frequency !== 'monthly' ? (parseFloat(value) / divisor).toFixed(2) : null;
    
    return (
        <div className="form-group" style={{ marginBottom: '16px' }}>
            <label style={{ fontSize: '0.9rem', marginBottom: '6px', display: 'block', fontWeight: '500' }}>{label}</label>
            <div className="input-with-icon" style={{ position: 'relative', marginBottom: '8px' }}>
                <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#6b7280' }}>₹</span>
                <input
                    type="number"
                    name={name}
                    value={inputValue}
                    onChange={onChange}
                    placeholder="0"
                    style={{ paddingLeft: '25px', width: '100%', padding: '8px 10px 8px 25px', borderRadius: '6px', border: '1px solid #d1d5db' }}
                    onWheel={(e) => {
                        e.target.blur();
                        e.stopPropagation();
                    }}
                />
            </div>
            <div className="frequency-options" style={{ display: 'flex', gap: '15px', paddingLeft: '2px', flexWrap: 'wrap' }}>
                {options.includes('monthly') && (
                    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '0.85rem', color: '#4b5563' }}>
                        <input 
                            type="radio" 
                            name={freqName} 
                            value="monthly" 
                            checked={frequency === 'monthly'} 
                            onChange={(e) => onFreqChange(e.target.value)}
                            style={{ margin: 0, marginRight: '6px', width: '16px', height: '16px', flexShrink: 0 }}
                        />
                        <span>Monthly</span>
                    </label>
                )}
                {options.includes('quarterly') && (
                    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '0.85rem', color: '#4b5563' }}>
                        <input 
                            type="radio" 
                            name={freqName} 
                            value="quarterly" 
                            checked={frequency === 'quarterly'} 
                            onChange={(e) => onFreqChange(e.target.value)}
                            style={{ margin: 0, marginRight: '6px', width: '16px', height: '16px', flexShrink: 0 }}
                        />
                        <span>Quarterly</span>
                    </label>
                )}
                {options.includes('annually') && (
                    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '0.85rem', color: '#4b5563' }}>
                        <input 
                            type="radio" 
                            name={freqName} 
                            value="annually" 
                            checked={frequency === 'annually'} 
                            onChange={(e) => onFreqChange(e.target.value)}
                            style={{ margin: 0, marginRight: '6px', width: '16px', height: '16px', flexShrink: 0 }}
                        />
                        <span>Annually</span>
                    </label>
                )}
            </div>
            
            {monthlyValue && frequency !== 'monthly' && (
                <div style={{ fontSize: '0.8rem', color: '#059669', background: '#f0fdf4', padding: '6px 10px', borderRadius: '4px', marginTop: '8px' }}>
                    <strong>Monthly Equivalent: ₹{parseFloat(monthlyValue).toLocaleString('en-IN', { maximumFractionDigits: 2 })}</strong>
                </div>
            )}
        </div>
    );
};

const InputGroup = ({ label, name, value, onChange }) => {
    const inputValue = value === null || value === undefined ? '' : String(value);
    return (
        <div className="form-group" style={{ marginBottom: '12px' }}>
            <label style={{ fontSize: '0.9rem', marginBottom: '4px', display: 'block' }}>{label}</label>
            <div className="input-with-icon" style={{ position: 'relative' }}>
                <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#6b7280' }}>₹</span>
                <input
                    type="number"
                    name={name}
                    value={inputValue}
                    onChange={onChange}
                    placeholder="0"
                    style={{ paddingLeft: '25px', width: '100%', padding: '8px 10px 8px 25px', borderRadius: '6px', border: '1px solid #d1d5db' }}
                    onWheel={(e) => {
                        e.target.blur();
                        e.stopPropagation();
                    }}
                    onKeyDown={(e) => {
                        if (['e', 'E', '+', '-', 'ArrowUp', 'ArrowDown'].includes(e.key)) {
                            e.preventDefault();
                        }
                    }}
                />
            </div>
        </div>
    );
};

const VacationPlanningInput = ({ amount, frequency, monthlyValue, onChange }) => {
    const frequencies = [
        { value: 'annually', label: 'Annually' },
        { value: 'sixMonthly', label: 'Six Monthly' }
    ];

    return (
        <div className="form-group" style={{ marginBottom: '15px' }}>
            <label style={{ fontSize: '0.9rem', marginBottom: '8px', display: 'block', fontWeight: '500' }}>
                Vacation Planning (Domestic/International)
            </label>
            
            {/* Amount Input */}
            <div className="input-with-icon" style={{ position: 'relative', marginBottom: '10px' }}>
                <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#6b7280' }}>₹</span>
                <input
                    type="number"
                    value={amount || ''}
                    onChange={(e) => onChange('vacationPlanningAmount', e.target.value)}
                    placeholder="Enter vacation budget"
                    style={{ paddingLeft: '25px', width: '100%', padding: '8px 10px 8px 25px', borderRadius: '6px', border: '1px solid #d1d5db' }}
                    onWheel={(e) => {
                        e.target.blur();
                        e.stopPropagation();
                    }}
                />
            </div>
            
            {/* Frequency Radio Buttons */}
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '8px' }}>
                {frequencies.map((freq) => (
                    <label
                        key={freq.value}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            padding: '6px 10px',
                            borderRadius: '4px',
                            border: frequency === freq.value ? '2px solid #059669' : '1px solid #d1d5db',
                            backgroundColor: frequency === freq.value ? '#ecfdf5' : '#fff',
                            cursor: 'pointer',
                            fontSize: '0.85rem',
                            color: frequency === freq.value ? '#059669' : '#4b5563'
                        }}
                    >
                        <input
                            type="radio"
                            name="vacationPlanningFrequency"
                            value={freq.value}
                            checked={frequency === freq.value}
                            onChange={(e) => onChange('vacationPlanningFrequency', e.target.value)}
                            style={{ margin: 0, marginRight: '8px', cursor: 'pointer', flexShrink: 0, width: '16px', height: '16px' }}
                        />
                        <span>{freq.label}</span>
                    </label>
                ))}
            </div>
            
            {/* Monthly Equivalent Display */}
            {monthlyValue && (
                <div style={{ fontSize: '0.8rem', color: '#059669', background: '#f0fdf4', padding: '6px 10px', borderRadius: '4px' }}>
                    <strong>Monthly Equivalent: ₹{parseFloat(monthlyValue).toLocaleString('en-IN', { maximumFractionDigits: 2 })}</strong>
                </div>
            )}
        </div>
    );
};

// Sports/Hobbies Input with Monthly/Annually Frequency
const SportsHobbiesInput = ({ amount, frequency, onChange }) => {
    const monthlyValue = parseFloat(amount) > 0 && frequency === 'annually' ? (parseFloat(amount) / 12).toFixed(2) : amount;
    
    return (
        <div className="form-group">
            <label>Sports/Gym/Hobbies (Photography, Arts, etc.)</label>
            <input 
                type="number" 
                value={amount} 
                onChange={(e) => onChange('sportsHobbiesAmount', e.target.value)}
                placeholder="Enter amount"
                className="form-control"
            />
            
            <div className="frequency-options" style={{ marginTop: '8px', display: 'flex', gap: '15px' }}>
                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                    <input 
                        type="radio" 
                        name="sportsHobbiesFrequency" 
                        value="monthly" 
                        checked={frequency === 'monthly' || !frequency} 
                        onChange={(e) => onChange('sportsHobbiesFrequency', e.target.value)}
                        style={{ margin: 0, marginRight: '6px', cursor: 'pointer', flexShrink: 0, width: '16px', height: '16px' }}
                    />
                    <span>Monthly</span>
                </label>
                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                    <input 
                        type="radio" 
                        name="sportsHobbiesFrequency" 
                        value="annually" 
                        checked={frequency === 'annually'} 
                        onChange={(e) => onChange('sportsHobbiesFrequency', e.target.value)}
                        style={{ margin: 0, marginRight: '6px', cursor: 'pointer', flexShrink: 0, width: '16px', height: '16px' }}
                    />
                    <span>Annually</span>
                </label>
            </div>
            
            {monthlyValue > 0 && frequency === 'annually' && (
                <div style={{ fontSize: '0.8rem', color: '#059669', background: '#f0fdf4', padding: '6px 10px', borderRadius: '4px', marginTop: '8px' }}>
                    <strong>Monthly Equivalent: ₹{parseFloat(monthlyValue).toLocaleString('en-IN', { maximumFractionDigits: 2 })}</strong>
                </div>
            )}
        </div>
    );
};

// Club Memberships Input with Half-Yearly/Annually Frequency
const ClubMembershipsInput = ({ amount, frequency, onChange }) => {
    const monthlyValue = parseFloat(amount) > 0 ? 
        (frequency === 'halfYearly' ? (parseFloat(amount) / 6).toFixed(2) : 
         frequency === 'annually' ? (parseFloat(amount) / 12).toFixed(2) : amount) : '';
    
    return (
        <div className="form-group">
            <label>Club Memberships</label>
            <input 
                type="number" 
                value={amount} 
                onChange={(e) => onChange('clubMembershipsAmount', e.target.value)}
                placeholder="Enter amount"
                className="form-control"
            />
            
            <div className="frequency-options" style={{ marginTop: '8px', display: 'flex', gap: '15px' }}>
                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                    <input 
                        type="radio" 
                        name="clubMembershipsFrequency" 
                        value="halfYearly" 
                        checked={frequency === 'halfYearly'} 
                        onChange={(e) => onChange('clubMembershipsFrequency', e.target.value)}
                        style={{ margin: 0, marginRight: '6px', cursor: 'pointer', flexShrink: 0, width: '16px', height: '16px' }}
                    />
                    <span>Half Yearly</span>
                </label>
                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                    <input 
                        type="radio" 
                        name="clubMembershipsFrequency" 
                        value="annually" 
                        checked={frequency === 'annually' || !frequency} 
                        onChange={(e) => onChange('clubMembershipsFrequency', e.target.value)}
                        style={{ margin: 0, marginRight: '6px', cursor: 'pointer', flexShrink: 0, width: '16px', height: '16px' }}
                    />
                    <span>Annually</span>
                </label>
            </div>
            
            {monthlyValue > 0 && (frequency === 'halfYearly' || frequency === 'annually') && (
                <div style={{ fontSize: '0.8rem', color: '#059669', background: '#f0fdf4', padding: '6px 10px', borderRadius: '4px', marginTop: '8px' }}>
                    <strong>Monthly Equivalent: ₹{parseFloat(monthlyValue).toLocaleString('en-IN', { maximumFractionDigits: 2 })}</strong>
                </div>
            )}
        </div>
    );
};

export default SalaryInvestmentForm;
